import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import AtomIcon, {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'

const baseClass = 'mt-modalDeleteAlert'

const ModalDeleteAlertAction = ({icon, onItemClick, text}) => {
  const {i18n} = useContext(Context)

  const wrapIcon = Icon => (
    <AtomIcon size={ATOM_ICON_SIZES.medium}>
      <Icon />
    </AtomIcon>
  )

  return (
    <div className={`${baseClass}-action`}>
      <div className={`${baseClass}-item`}>
        <span className={`${baseClass}-icon`}>{wrapIcon(icon)}</span>
        <p className={`${baseClass}-text`}>{text}</p>
      </div>
      <div className={`${baseClass}-button`}>
        <AtomButton
          design={atomButtonDesigns.OUTLINE}
          onClick={onItemClick}
          shape={atomButtonShapes.CIRCULAR}
          size={atomButtonSizes.SMALL}
          fullWidth
        >
          {i18n.t('SEARCH.UPDATE')}
        </AtomButton>
      </div>
    </div>
  )
}

ModalDeleteAlertAction.displayName = 'ModalDeleteAlertAction'

ModalDeleteAlertAction.propTypes = {
  icon: PropTypes.node,
  onItemClick: PropTypes.func,
  text: PropTypes.string
}

export default ModalDeleteAlertAction
